import { EnvironmentInterface } from './environment-interface';

export const environment: EnvironmentInterface = {
  name: 'production',
  production: false,
  apiUrl: 'https://api.bathdream.ms-dev.ru',
  messengerUrl: 'https://messenger.bathdream.ms-dev.ru',
  cookieDomain: '.bathdream.ms-dev.ru',
  orderPageIconBasePath: '/assets/img/bathdream',
};
